import { PolicyService } from '@modules/policy/policy.service';
import { PolicyState } from '@shared/models/state.model';
import { JsonFormFetcherService } from './../../../services/shared/json-form-fetcher.service';
import { PolicyDataService } from '@modules/policy/services/shared/policy-data.service';
import { Component, OnInit } from '@angular/core';
import { zip, Subscription } from 'rxjs';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {

  policyId: string;
  tab: string;
  tabState: any;
  subTabList: any[];
  readOnlyPolicy: boolean;
  initSubscription: Subscription;
  tabConfig: any;

  constructor(
    private PolicyDataService: PolicyDataService,
    private JsonFormFetcherService: JsonFormFetcherService,
    private policyService: PolicyService
  ) { }

  ngOnInit() {
    this.tab = "client";
    this.policyId = this.PolicyDataService.getPolicyID();
    this.PolicyDataService.getPolicyStates(this.policyId).subscribe(tree => {
      this.PolicyDataService.updateStates(tree);
      const name = tree?.client?.clientInformation?.$name;
      if (name != null) {
        setTimeout(() => {
          if (this.subTabList) {
            this.subTabList = this.subTabList.map(s =>
              s.formName === 'clientInformation' ? { ...s, label: name } : s
            );
          }
        }, 0);
      }
    });
    const stateSubject = this.PolicyDataService.stateSubject;
    const configSubject = this.JsonFormFetcherService.tabsConfigSubject;
    const policyReadOnlySubject = this.PolicyDataService.policyReadOnly;
    this.initSubscription = zip(stateSubject, configSubject, policyReadOnlySubject).subscribe(res => {
      const [states, config, readOnly] = res;
      this.readOnlyPolicy = readOnly;
      this.tabConfig = config.tabs.find(tab => tab.tabKey == this.tab);
      this.loadTabs(config["tabs"], states);
    });
  }

  loadTabs(tabs: any, states: PolicyState) {
    this.tabState = states.client;
    const tabConfig = tabs.find((tab: { tabKey: string; }) => tab.tabKey == this.tab);
    this.subTabList = tabConfig.subTabs;
    this.modifySubtabs(this.policyId);
  }

  modifySubtabs(policyId: string) {
    this.subTabList = this.subTabList.map(subtab => {
      const formId = this.tabState[subtab.formName].id;
      const label = subtab.formName === 'clientInformation'
        ? (this.tabState?.clientInformation?.$name || 'Primary Client')
        : subtab.label;
      return {
        ...subtab,
        label,
        formId,
        fullRoute: subtab.fullRoute.replace(':policyId', policyId),
      }
    });
  }

  isFormValid(formId: number) {
    let result: boolean = false;
    if (this.policyService.getForm(formId)) {
      result = this.policyService.getForm(formId).status !== 'INVALID';
    }
    return result;
  }

  ngOnDestroy() {
    this.initSubscription?.unsubscribe();
  }
}
